import React, { useEffect, useRef, useState } from "react";
// import { Map } from '@googlemaps/react-wrapper'
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import iconn from "../Markers/location.png";
import { mineData } from "../data";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import SitesSideBar from "../components/SitesSideBar";
import Spinner from "../components/Spinner";
import FormModal from "../components/FormModal";
import { MAPS_API } from "../data";

const mapStyles = {
    width: "110%",
    height: "110%",

    position: "absolute",
};
const darkTheme = [
        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#38414e" }]
        },
      ];

const MapView = (props) => {
    const navigate = useNavigate();
    const [isMapLoaded, setIsMapLoaded] = useState(false);
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [labeledMarkers, setLabeledMarkers] = useState(mineData);

    function createMarkerWithLabel(url, labelText) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 100;
        canvas.height = 100;

        // Draw text
        ctx.font = "bold 14px Arial";
        ctx.textAlign = "center";
        ctx.lineWidth = 2; // thickness of outline
        ctx.strokeStyle = "black";
        ctx.fillStyle = "cyan";
        ctx.fillText(labelText, 60, 40);

        // Draw marker image
        const img = new Image();
        img.src = url;
        return new Promise((resolve) => {
            img.onload = () => {
                ctx.drawImage(img, 38, 40, 45, 45); // position image under text
                resolve(canvas.toDataURL());
            };
        });
    }

    useEffect(() => {
        try {
            if (map) {
                map.setMapTypeId("satellite");
                map.setOptions({styles:darkTheme})
            }
            setTimeout(() => {
                setIsMapLoaded(true);
            }, 2000);
        } catch (err) {
            console.log(err.message);
        }
    }, [map]);

    useEffect(() => {
        async function loadMarkers() {
            const updated = [];
            for (let m of mineData) {
                const iconUrl = await createMarkerWithLabel(iconn, m.id);
                updated.push({ ...m, iconUrl });
            }
            setLabeledMarkers(updated);
        }
        loadMarkers();
    }, []);

    return (
        <>
            <Map
                google={props.google}
                zoom={5}
                style={mapStyles}
                streetViewControl={false}
                initialCenter={{
                    lat: 20.5937,
                    lng: 78.9629,
                }}
                disableDefaultUI={true}
                minZoom={3}
                ref={mapRef}
                onReady={(mapProps, mapObj) => setMap(mapObj)}
            >
                {labeledMarkers?.map((marker, i) => {
                    return (
                        <Marker
                            key={`mapview_card_${
                                marker.location.lat.toString() +
                                marker.location.lng
                            }`}
                            position={marker.location}
                            icon={{
                                url: marker.iconUrl,
                                scaledSize: props.google
                                    ? new props.google.maps.Size(100, 100)
                                    : 1,
                            }}
                            style={{ width: "16px" }}
                            // onClick={() => navigate("/dashboard/maps/" + marker.id)}
                            onClick={() => navigate("/dashboard/maps/"+(i+1))}
                            title={marker.name}
                        />
                    );
                })}
            </Map>
        </>
    );
};

export default GoogleApiWrapper({
    apiKey: MAPS_API,
})(MapView);
